import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

import DefaultScreenContent from '@/components/DefaultScreenContent.vue';
import CrudGrid from '@/../bower_components/teknisavuecomponents/components/grids/CrudGrid.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import ConfirmationDialog from '@/../bower_components/teknisavuecomponents/components/popups/ConfirmationDialog.vue';
import itemSolicitacaoPopup from '@/components/itemSolicitacaoPopup/itemSolicitacaoPopup.vue';
import RowPopUp from '@/../bower_components/teknisavuecomponents/components/popups/RowPopUp.vue';
import NovaSolicitacaoPopup from '@/components/NovaSolicitacaoPopup/NovaSolicitacaoPopup.vue';
import { SolicitacaoAprovacao, SolicitacaoController } from '@/assets/ts/controller/SolicitacaoController';
import AprovacaoSolicitacao from '@/components/AprovacaoSolicitacao/AprovacaoSolicitacao.vue';
import AprovacaoVariasSolicitacoes from '@/components/AprovacaoVariasSolicitacoes/AprovacaoVariasSolicitacoes.vue';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';
import PopupController from '@/assets/ts/controller/PopupController';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import LoadingController from '@/assets/ts/controller/LoadingController';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';
import DocumentosSolicitacao from '@/components/documentos/DocumentosSolicitacao/DocumentosSolicitacao.vue';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import { ExportType } from '@/assets/ts/controller/ExportRelatController';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

 
@Component({
  name: 'Solicitacao',
  components: {
    DefaultScreenContent,
    CrudGrid,
    EditableTable,
    ConfirmationDialog,
    itemSolicitacaoPopup,
    RowPopUp,
    NovaSolicitacaoPopup,
    AprovacaoSolicitacao,
    AprovacaoVariasSolicitacoes,
    DocumentosSolicitacao,
    TkVisualizer,
  },
})
class Solicitacao extends Vue {
  // #region [ STORE ]
  @Getter('user')
  private user: User;

  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: Periodo;

  @Getter('estruturaGerencialAtual')
  private estruturaGerencialAtual: any;

  @Mutation('changeCurrentView')
  private changeCurrentView: (viewTitlw: string) => void;

  @Getter('estruturasGerenciais')
  private readonly estruturasGerenciais: any[];

  @Mutation('updateEstruturaGerencialAtual')
  private updateEstruturaGerencialAtual: (any) => void;
  // #endregion

  // #region [ DATA ]

  private loading = false;
  private showitemSolicitacaoPopup = false;
  private showAprovaSolicitacaoPopup = false;
  private showAprovaVariasSolicitacoesPopup: { type: 'A' | 'R', open: boolean } = {
    type: 'A', open: false
  };
  private reloadItemSolicitacao = 0;
  private selectedNrSolicitacao: any = null;
  private newSolicitacao: any = {};
  private salarioAtual: number;
  private gridFooterNote = '*Solicitações já aprovadas/recusadas ou cuja fase atual não seja passível de aprovação não terão as opções "Aprovar" ou "Recusar" disponíveis.';
  private rowsSelected: any[] = [];
  private vinculos: any[] = [];
  private tiposSolicitacao: any[] = [];
  private searchValue = '';
  private vinculoLoading = false;

  private solicitacaoAprovacao: SolicitacaoAprovacao = {
    NRSOLICITACAO: null,
    NRTIPOSOLICITACAO: null,
    NRVINCULOM: null,
    NMVINCULOM: null,
    NMFASEAPROVSOLI: null,
    NMTIPOSOLICITACAO: null,
  };

  private documentosPopup = {
    show: false,
    nrSolicitacao: null,
    title: 'Documentos',
    nrVinculo: '',
    triggerReload: 0,
  };

  private solicitacoesSelected: any[] = [];

  private tableRows: any[];
  private allRows: any[];

  private selectedRow: any[] = [];

  private vinculoFilters: any = {
    NRPERIODOAPURACAO: this.nrPeriodo,
    NRESTRUTURAM: this.nrEstrutura,
    NRORG: this.$store.state.user.nrorg,
  };

  private view = {
    title: 'Solicitação',
    popUpTitle: 'Solicitação',
  };

  private grid = {
    name: this.view.popUpTitle,
    messages: {
      loadingText: 'Carregando Solicitações...',
      noDataText: 'Nenhuma Solicitação Encontrada.',
    },
    triggers: {
      reload: 0,
    },
    dataSource: {
      route: 'getSolicitacoesVinculosGestor',
      filters: {
        NRORG: this.$store.state.user.nrorg,
        NRESTRUTURAM: this.$store.state.estruturaGerencialAtual.NRESTRUTURAM,
        NRPERIODOAPURACAO: this.$store.state.periodoDemonstrativoAtual.NRPERIODOAPURACAO,
        CDOPERADOR_APROVANTE: this.$store.state.user.cdoperador,
      },
    },
    toolbarActions: [
      'reload',
      {
        name: 'addSolicitacao',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: ControleAcessoWrapper.criar(this.openNovaSolicitacaoPopup),
      },
      {
        name: 'exportDataOptions',
        label: 'Exportar para Relatório',
        icon: 'mdi-file-export-outline',
        menu: true,
        items: [
          {
            name: 'exportToPdf',
            label: 'Exportar para PDF',
            onClick: this.generateReportPDF,
          },
          {
            name: "exportToXls",
            label: "Exportar para XLS",
            onClick: this.generateSolicitacaoCustomReportXLS
          },
        ],
      },
      {
        name: 'aprovar',
        label: 'Aprovar',
        showLabel: true,
        icon: 'mdi-check-all',
        disabled: true,
        onClick: ControleAcessoWrapper.atualizar(this.aprovarTodos),
      },
      {
        name: 'reprovar',
        label: 'Reprovar',
        showLabel: true,
        icon: 'cancel',
        disabled: true,
        onClick: ControleAcessoWrapper.atualizar(this.reprovarTodos),
      },
    ],
    columns: [
      {
        text: 'Nr. Vínculo',
        value: 'NRVINCULOM',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: true,
        showOnForm: false,
      },
      {
        value: 'NMVINCULOM',
        text: 'Vínculo',
        cols: 9,
        tag: 'TkSelect',
        autocomplete: true,
        valueField: 'NRVINCULOM',
        descriptionField: 'NMVINCULOM',
        route: 'getVinculosDoGestor',
        filters: this.vinculoFilters,
        required: true,
        reloadOnCreation: false,
        reloadOnClick: true,
        triggerReload: 0,
      },
      {
        text: 'Estr. Legal',
        value: 'NMESTRUTLEGAL',
        type: 'text',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: true,
        showOnForm: false,
      },
      {
        text: 'Estr. Gerencial',
        value: 'NMESTRUTGEREN',
        type: 'text',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: true,
        showOnForm: false,
      },
      {
        text: 'Nr. Solicitação',
        value: 'NRSOLICITACAO',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
        showOnForm: false,
      },
      {
        text: 'Data de Solicitação',
        value: 'DTSOLICITACAO',
        type: 'date',
        cols: 3,
        tag: 'TkDate',
        defaultValue: DateUtil.getCurrentDate(),
        required: true,
        showOnForm: true,
      },
      {
        text: 'Tipo de Solicitação',
        cols: 6,
        tag: 'TkSelect',
        value: 'NMTIPOSOLICITACAO',
        valueField: 'NRTIPOSOLICITACAO',
        descriptionField: 'NMTIPOSOLICITACAO',
        route: 'getTiposolicitacao',
        filters: this.vinculoFilters,
        required: true,
        reloadOnCreation: true,
        reloadOnClick: true,
      },
      {
        text: 'Observação',
        value: 'DSOBSSOLICITACAOABREV',
        type: 'text',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: true,
        showOnForm: false,
      },
      {
        text: 'Aprovação',
        value: 'DSAPROVACAOSEC',
        valueField: 'IDAPROVACAOSEC',
        descriptionField: 'DSAPROVACAOSEC',
        readonly: true,
        hideEmptyValue: true,
        defaultValue: {IDAPROVACAOSEC: 'P', DSAPROVACAOSEC: 'Pendente' },
        type: 'text',
        cols: 3,
        tag: 'TkSelect',
        items: [
          {
            IDAPROVACAOSEC: 'A',
            DSAPROVACAOSEC: 'Aprovada',
          },
          {
            IDAPROVACAOSEC: 'R',
            DSAPROVACAOSEC: 'Reprovada',
          },
          {
            IDAPROVACAOSEC: 'P',
            DSAPROVACAOSEC: 'Pendente',
          },
          {
            IDAPROVACAOSEC: 'E',
            DSAPROVACAOSEC: 'Em andamento',
          },
        ],
      },
      {
        text: 'Fase atual',
        value: 'NMFASEAPROVSOLI',
        type: 'text',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: true,
        showOnForm: false,
      },
      {
        text: 'Observação',
        value: 'DSOBSSOLICITACAO',
        type: 'text',
        cols: 12,
        tag: 'v-text-field',
        showOnList: false,
        isVisible: false,
      },
    ],
    actions: [
      {
        label: 'Detalhes',
        value: 'detalhes',
        icon: 'mdi-eye',
        onClick: this.viewDetailsActionOnClick,
        mode: 'view',
      },
      {
        label: 'Aprovar',
        value: 'aprovar',
        icon: 'mdi-check',
        onClick: ControleAcessoWrapper.atualizar(this.aprovaSolicitacao),
        mode: 'view',
        condition: this.visibleConditionApproveActions,
      },
      {
        label: 'Reprovar',
        value: 'reprovar',
        icon: 'mdi-close',
        onClick: ControleAcessoWrapper.atualizar(this.reprovaSolicitacao),
        mode: 'view',
        condition: this.visibleConditionReproveActions,
      },
      {
        label: 'Ver Arquivos',
        value: 'viewFile',
        icon: 'mdi-file-eye',
        onClick: this.viewFile,
        mode: 'view',
        condition: this.solicitacaoHasFile,
      },
      {
        label: 'Editar',
        value: 'editar',
        icon: 'mdi-pencil',
        onClick: ControleAcessoWrapper.atualizar(this.openEditOnClick),
        mode: 'view',
        condition: this.visibleConditionEditSolicitacao,
      },
      {
        label: 'Cancelar Solicitação',
        value: 'cancelarDesligamento',
        icon: 'mdi-cancel',
        onClick: this.cancelaSolicitacao,
        mode: 'view',
        condition: this.visibleConditionCancelSolicitacao,
      },
    ],
  };

  private visualizer = {
    show: false,
    base64: '',
    mimeType: '',
    fileName: '',
  };

  private confirmationDialog = {
    isVisible: false,
    message: '',
    icon: '',
  };

  private showSolicitacaoPopup = false;
  private isEdit = false;

  private filterStatus: string[] = [];
  private filterPeriodo: string[] = [];
  private filterAprovStatus = false;

  private statusSoli = {
    aprovada: 'A',
    reprovada: 'R',
    pendente: 'P',
    emAndamento: 'E',
  };
  // #endregion

  // #region [ COMPUTED ]
  private get nrOrg() {
    const user = this.$store.getters.user;

    const nrOrg = user ?
      user.nrorg :
      undefined;

    return nrOrg;
  }

  private get nrPeriodo(): string {
    const periodoAtual = this.$store.state.periodoDemonstrativoAtual;

    const nrPeriodoAPuracao = periodoAtual ?
      periodoAtual.NRPERIODOAPURACAO :
      undefined;

    return nrPeriodoAPuracao;
  }

  private get nrEstrutura(): number {
    const estruturaAtual = this.$store.state.estruturaGerencialAtual;

    const nrEstruturaGerencial = estruturaAtual ?
      estruturaAtual.NRESTRUTURAM :
      undefined;

    return nrEstruturaGerencial;
  }

  private get rowFilters() {
    return [this.filterRows];
  }

  private get isFilterAprovadasActive() {
    return this.filterStatus.includes(this.statusSoli.aprovada);
  }

  private get isFilterPendentesActive() {
    return this.filterStatus.includes(this.statusSoli.pendente);
  }

  private get isFilterReprovadasActive() {
    return this.filterStatus.includes(this.statusSoli.reprovada);
  }

  private get isFilterEmAndamentoActive() {
    return this.filterStatus.includes(this.statusSoli.emAndamento);
  }
  
  private get isFilterPeriodoActive() {
    return this.filterPeriodo.length > 0;
  }

  private get noFilterActive() {
    return !this.filterAprovStatus &&
      !this.isFilterAprovadasActive &&
      !this.isFilterPendentesActive &&
      !this.isFilterReprovadasActive &&
      !this.isFilterEmAndamentoActive &&
      !this.isFilterPeriodoActive;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.view.title);
    this.filterOnEnter();
    this.setFiltersByQueryURL();
    this.loadVinculos();
    this.loadTiposSolicitacao();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('periodoDemonstrativoAtual')
  private onChangePeriodo(newPeriodo: Periodo) {
    this.grid.dataSource.filters.NRPERIODOAPURACAO = newPeriodo.NRPERIODOAPURACAO;
    this.reloadGridData();
  }

  @Watch('estruturaGerencialAtual')
  private onChangeEstrutura(newEstrutura: any) {
    this.$forceUpdate();
    this.grid.dataSource.filters.NRESTRUTURAM = newEstrutura.NRESTRUTURAM;
    this.vinculoFilters.NRESTRUTURAM = newEstrutura.NRESTRUTURAM;
    this.loadVinculos();
    this.reloadGridData();
    this.grid.columns[1].triggerReload++;
  }

  @Watch('rowsSelected')
  private changeAction() {
    this.changeDisabledActions();
  }
  // #endregion

  // #region [ METHODS ]
  private reloadGridData() {
    return this.grid.triggers.reload++;
  }

  private changeDisabledActions() {
    const areAdditionalActionsDisabled = !this.rowsSelected.length; 
    this.grid.toolbarActions.forEach((action) => {
      if(typeof action === 'string') return;
      if(action.name == 'aprovar' || action.name == 'reprovar') {
        action.disabled = areAdditionalActionsDisabled;
      }
    });
  }

  private async loadVinculos() {
    this.vinculoLoading = true;
    try {
      const vinculos = await CommonRequests.getVinculosDoGestor(false);
      this.vinculos = vinculos;
    } finally {
      this.vinculoLoading = false;
      this.loading = false;
    }
    
  }

  private async loadTiposSolicitacao() {
    const tiposSolicitacao = await NovaSolicitacaoController.getTiposSolicitacao(null, false);
    this.tiposSolicitacao = tiposSolicitacao;
  }

  private openItensPopup(row: any) {
    this.selectedNrSolicitacao = row.NRSOLICITACAO;

    this.showitemSolicitacaoPopup = true;
    this.reloadItemSolicitacao++;
  }

  private openNovaSolicitacaoPopup() {
    this.showSolicitacaoPopup = true;
    this.selectedRow = [];
    this.isEdit = false;
  }

  private novaSolicitacaoAfterSave() {
    this.reloadGridData();
  }

  private openEditOnClick(row: any[]) {
    this.isEdit = true;
    this.selectedRow = row;
    this.showSolicitacaoPopup = true;
  }

  private async aprovaSolicitacao(row: SolicitacaoAprovacao) {
    row = this.setRowAsAprovado(row);
    this.showAprovacaoSolicitacaoPopup(row);
  }

  private async reprovaSolicitacao(row: SolicitacaoAprovacao) {
    row = this.setRowAsReprovado(row);
    this.showAprovacaoSolicitacaoPopup(row);
  }


  private async cancelaSolicitacao(row: SolicitacaoAprovacao) {
    row = this.setRowAsCancelado(row);
    this.showAprovacaoSolicitacaoPopup(row);
  }

  private setRowAsAprovado(row: SolicitacaoAprovacao): SolicitacaoAprovacao {
    row.IDAPROVACAO = 'A';
    return row;
  }

  private setRowAsReprovado(row: SolicitacaoAprovacao): SolicitacaoAprovacao {
    row.IDAPROVACAO = 'R';
    return row;
  }

  private setRowAsCancelado(row: SolicitacaoAprovacao): SolicitacaoAprovacao {
    row.IDAPROVACAO = 'C';
    row.DSOBSERVACAO = 'Cancelamento da Solicitação de Desligamento'
    return row;
  }

  private visibleConditionApproveActions(row: { ID_OPER_APROVA_SOLI: string, IDEFETIVADO: string }) {
    return row.ID_OPER_APROVA_SOLI === 'S';
  }

  private visibleConditionReproveActions(row: { ID_OPER_APROVA_SOLI: string, IDEFETIVADO: string }) {
    return row.ID_OPER_APROVA_SOLI === 'S' && row.IDEFETIVADO !== 'S';
  }

  private visibleConditionEditSolicitacao(row: {
    NRSOLICITACAO: number,
    IDAPROVACAOSEC: string,
    NRFASEAPROVSOLI: string,
    CDOPERADOR: string,
    OPERADORES_APROVADORES_FASE: string | null
  }): boolean {
    const cdOperadorAtual = this.$store.state.user.cdoperador;

    const isSolicitante = row.CDOPERADOR === cdOperadorAtual;

    const operadores = row.OPERADORES_APROVADORES_FASE
      ? row.OPERADORES_APROVADORES_FASE.split(' | ').map(op => op.trim())
      : [];
    
    const isOperadorAprovador = operadores.includes(cdOperadorAtual);

    return row.IDAPROVACAOSEC === 'R' && (isSolicitante || isOperadorAprovador);
  }

  private visibleConditionCancelSolicitacao(row: { IDAPROVACAOSEC: string, NRFASEAPROVSOLI: string, CDOPERADOR: string, NRTIPOSOLICITACAO: string}) {
    return (row.IDAPROVACAOSEC === 'A')
            && (row.NRTIPOSOLICITACAO === '5') && (this.user.dp);
  }

  private aprovacaoSolicitacaoOnClose() {
    this.reloadGridData();
  }
  
  private showAprovacaoSolicitacaoPopup(solicitacao: SolicitacaoAprovacao) {
    this.solicitacaoAprovacao = { ...solicitacao };
    this.showAprovaSolicitacaoPopup = true;
  }

  private filterAprovadas() {
    this.toggleStatusFilter(this.statusSoli.aprovada);
  }

  private filterPendentes() {
    this.toggleStatusFilter(this.statusSoli.pendente);
  }

  private filterReprovadas() {
    this.toggleStatusFilter(this.statusSoli.reprovada);
  }

  private filterEmAndamento() {
    this.toggleStatusFilter(this.statusSoli.emAndamento);
  }

  private toggleFilterAprovStatus() {
    this.filterAprovStatus = !this.filterAprovStatus;
  }
  
  private toggleFilterPeriodo() {
    const dtIniApuracao = this.$store.state.dtIniApuracao;
    const dtFimApuracao = this.$store.state.dtFimApuracao;

    if (this.filterPeriodo.length == 0) {
      this.filterPeriodo.push(dtIniApuracao);
      this.filterPeriodo.push(dtFimApuracao);
      return;
    }
    
    this.filterPeriodo = [];
  }

  private toggleStatusFilter(status: string) {
    if (!this.filterStatus.includes(status)) {
      this.filterStatus.push(status);
      return;
    }

    const itemIndex = this.filterStatus.indexOf(status);
    if (itemIndex !== -1) {
      this.filterStatus.splice(itemIndex, 1);
    }
  }

  private filterRows(row) {
    return this.filterSoliByAprovStatus(row) || this.filterSoliByStatus(row) || this.filterSoliByPeriodo(row) || this.noFilterActive;
  }

  private filterSoliByPeriodo(row: any) {
    if (Util.isEmptyOrBlank(row) || this.filterPeriodo.length == 0) {
      return false;
    }

    const iniPeriodo = DateUtil.stringToDate(this.filterPeriodo[0]);
    const fimPeriodo = DateUtil.stringToDate(this.filterPeriodo[1]);
    const dataSoli = DateUtil.stringToDate(row.DTSOLICITACAO);
    
    return DateUtil.compareDates(dataSoli, iniPeriodo) == 1 && DateUtil.compareDates(dataSoli, fimPeriodo) == -1;
  }

  private filterSoliByStatus(row: any) {
    if (Util.isEmptyOrBlank(row) || this.filterStatus.length < 1) {
      return false;
    }
    return this.filterStatus.includes(row.IDAPROVACAOSEC);
  }

  private filterSoliByAprovStatus(row: any) {
    if (Util.isEmptyOrBlank(row) || !this.filterAprovStatus) {
      return false;
    }
    return this.visibleConditionApproveActions(row);
  }
  
  private hasFile(
    row: any,
  ): boolean {
    const solicitacaoHasFile = !Util.isEmptyOrBlank(row.DSPATH);

    return solicitacaoHasFile;
  }

  private solicitacaoHasFile(row: any): boolean {
    return row.ID_EXIST_ARQUIVOS === 'S';
  }

  private async viewFile(row: any) {
    const nrSolicitacao: string = row.NRSOLICITACAO;
    const nrVinculo = row.NRVINCULOM;
    this.documentosPopup.nrSolicitacao = nrSolicitacao;
    this.documentosPopup.nrVinculo = nrVinculo;
    this.documentosPopup.title = `Documentos | Solicitação - ${nrSolicitacao}`;
    this.documentosPopup.show = true;

    /*
    this.loading = true;

    try {
      const fileData = await SolicitacaoController.getSolicitacaoFile(nrSolicitacao);
      const { base64, type } = fileData;

      const fullBase64 = FileUtils.getFullBase64(
        base64, type
      );

      const fileName = `solicitacao${nrVinculo}_${nrSolicitacao}`;

      this.visualizer.show = true;
      this.visualizer.base64 = fullBase64;
      this.visualizer.mimeType = type;
      this.visualizer.fileName = fileName;
    } finally {
      this.loading = false;
    }*/
  }

  private viewDetailsActionOnClick(row: any) {
    PopupController.openPopup('detalhesSolicitacao', {
      nrSolicitacao: row.NRSOLICITACAO, nmTipoSolicitacao: row.NMTIPOSOLICITACAO,
      nmVinculo: row.NMVINCULOM, statusSolicitacao: row.DSAPROVACAOSEC,
      dataSolicitacao: row.DTSOLICITACAO, faseAtualSolicitacao: row.NMFASEAPROVSOLI,
      nmSolicitante: row.NMOPERADOR, dsObservacao: row.DSOBSSOLICITACAO
    });
  }

  private filterOnEnter() {
    if (this.$route.query.filterAprovStatus && this.$route.query.filterAprovStatus == 's') {
      this.filterAprovStatus = true;
    }
  }

  private tableAfterReload(rows: any[]): void {
    this.rowsSelected = [];
    this.verificaLoadVinculo();
    this.allRows = rows;
  }

  private tableAfterReloadPage(rows: any[]): void {
    this.tableRows = rows;
  }

  private verificaLoadVinculo() {
    if(this.vinculoLoading) {
      this.loading = true;
    }
  }

  private aprovarTodos() { 
    this.solicitacoesSelected = this.rowsSelected;
    this.showAprovaVariasSolicitacoesPopup.type = 'A';
    this.showAprovaVariasSolicitacoesPopup.open = true;
  }

  private reprovarTodos() { 
    this.solicitacoesSelected = this.rowsSelected;
    this.showAprovaVariasSolicitacoesPopup.type = 'R';
    this.showAprovaVariasSolicitacoesPopup.open = true;
  }


  private setFiltersByQueryURL() {
    const nrSolicitacao = this.$route.query.NRSOLICITACAO;
    const nrEstruturam = this.$route.query.NRESTRUTURAM;
    if(nrSolicitacao && typeof nrSolicitacao === 'string') {
      this.searchValue = nrSolicitacao;
    }

    if(nrEstruturam && typeof nrEstruturam === 'string') {
      const estruturaAtual = this.estruturasGerenciais.find((p: any) => p.value == nrEstruturam);
      if(estruturaAtual) {
        this.updateEstruturaGerencialAtual(estruturaAtual);
      }
    }
  }

  private async generateSolicitacaoCustomReportXLS() {
    await DialogUtils.show('Aviso', `Todos os dados filtrados serão exportados para um relatório xls, deseja continuar?`);

    const rows = (this.rowsSelected && this.rowsSelected.length > 0) ? this.rowsSelected : this.allRows;
    const dataFiltered = rows.filter(row => this.filterRows(row));

    const nrSolicitacoesArray = dataFiltered.map((mp) => mp.NRSOLICITACAO );
    const nrSolicitacoesString = `,${nrSolicitacoesArray.toString()},`;

    const { fileName, base64, type } = await SolicitacaoController.generateSolicitacaoCustomReportXLS(nrSolicitacoesString);

    await FileUtils.downloadBase64File(fileName, base64, type);
  
  }

  private async generateReportPDF() {
    const exportType = ExportType.PDF;

    await DialogUtils.show('Aviso', `Todos os dados filtrados serão exportados para um relatório ${exportType}, deseja continuar?`);

    const rows = (this.rowsSelected && this.rowsSelected.length > 0) ? this.rowsSelected : this.allRows;
    const dataFiltered = rows.filter(row => this.filterRows(row));

    const dataReduced = dataFiltered.map(data => {
      const commonFields = {
        NRVINCULOM: data.NRVINCULOM,
        NMVINCULOM: data.NMVINCULOM,
        NMESTRUTLEGAL: data.NMESTRUTLEGAL,
        NMESTRUTGEREN: data.NMESTRUTGEREN,
        NRSOLICITACAO: data.NRSOLICITACAO,
        DTSOLICITACAO: data.DTSOLICITACAO,
        NMTIPOSOLICITACAO: data.NMTIPOSOLICITACAO.replace("Solicitação de ", ""),
        DSAPROVACAOSEC: data.DSAPROVACAOSEC,
        NMFASEAPROVSOLI: data.NMFASEAPROVSOLI,
        DSOBSSOLICITACAO: data.DSOBSSOLICITACAOABREV || "",
      };
    
      return commonFields;
    });

    const columns = [
      "N° Vínculo",
      "Vínculo",
      "Estrutura Legal",
      "Estrutura Gerencial",
      "N° Solicitação",
      "Data de Solicitação",
      "Tipo de Solicitação",
      "Status da Solicitação",
      "Próxima Fase",
      "Observação",
    ];
    
    const columnMapping = {
      "N° Vínculo": "NRVINCULOM",
      "Vínculo": "NMVINCULOM",
      "Estrutura Legal": "NMESTRUTLEGAL",
      "Estrutura Gerencial": "NMESTRUTGEREN",
      "N° Solicitação": "NRSOLICITACAO",
      "Data de Solicitação": "DTSOLICITACAO",
      "Tipo de Solicitação": "NMTIPOSOLICITACAO",
      "Status da Solicitação": "DSAPROVACAOSEC",
      "Próxima Fase": "NMFASEAPROVSOLI",
      "Observação": "DSOBSSOLICITACAO",
    };

    // Definir larguras manualmente
    const columnWidths = {
      "N° Vínculo": 100,
      "Vínculo": 250,
      "Estrutura Legal": 250,
      "Estrutura Gerencial": 300,
      "N° Solicitação": 100,
      "Data de Solicitação": 100,
      "Tipo de Solicitação": 250,
      "Status da Solicitação": 150,
      "Próxima Fase": 150,
      "Observação": 400,
    };

    SolicitacaoController.generatePdfReport('Solicitações', 'Solicitações', dataReduced, columns, columnMapping);
  }

  // #endregion
}

export default Solicitacao;

